import { sendAmplitudeData, setAmplitudeUserId } from './amplitude';
import { sendFirebaseEvent, setUserId } from './firebase';
import { sendLockerStudioData } from './lockerStudio';
import biEvents from './biEvents';
import ReactGA from 'react-ga4';
import {
  REACT_APP_GOOGLE_TRACKING_ID,
  REACT_APP_GOOGLE_ADS_ID,
  GOOGLE_ADS_CONVERSION_ID,
} from './GA';
import { fetchWrapper } from '../utils';

const isStage = process.env.REACT_APP_ENV === 'stage';
const REACT_APP_RUNWAYER_URL = process.env.REACT_APP_RUNWAYER_URL;

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
  const biEventName = biEvents[eventName] || eventName;

  sendAmplitudeData(eventName, eventParams);
  sendFirebaseEvent(eventName, eventParams);
  sendLockerStudioData(biEventName, eventParams);
};

export const setAnalyticsUserId = (userId = '') => {
  setAmplitudeUserId(userId);
  setUserId(userId);
};

export const pushFBEvent = (data, eventId) => {
  if (window.fbq) {
    window.fbq('track', `Purchase${isStage ? '_test' : ''}`, data, {
      eventID: eventId,
    });
  }
};

export const sendPurchaseEvent = (
  price,
  currency,
  plan,
  sub_id,
  event_id,
  gclid = '',
  pixelName,
  upsell = false
) => {
  if (pixelName === 'fb') {
    pushFBEvent(
      {
        currency: currency || 'USD',
        itemCount: 1,
        transactionId: sub_id,
        price: price,
        value: price,
      },
      event_id
    );
  } else if ('ttq') {
    window?.ttq?.track('CompletePayment', {
      value: price,
      currency: currency || 'USD',
      contents: [
        {
          content_type: 'product',
          content_name: plan,
        },
      ],
      event_id,
    });
  }
  if (!isStage) {
    ReactGA.event('purchase', {
      currency: currency || 'USD',
      value: price,
      transaction_id: sub_id,
      gclid,
      items: {
        item_id: plan,
        item_name: plan,
      },

      send_to: REACT_APP_GOOGLE_TRACKING_ID,
    });
    ReactGA.event('conversion', {
      send_to: `${REACT_APP_GOOGLE_ADS_ID}/${GOOGLE_ADS_CONVERSION_ID}`,
      value: price,
      currency: currency || 'USD',
      transaction_id: sub_id,
    });
  }
};

export const sendRunwayerConversion = (body) => {
  fetchWrapper(REACT_APP_RUNWAYER_URL, { body })
    .then((data) => console.log(data))
    .catch((err) => console.log(err));
};
